import equalByNameAndPaymentParametersId from '../../utils/equalByNameAndPaymentParametersId';
import {
  i18n
} from "../../../vue-i18n";

export default class ChangePaymentFrequency {
  constructor(paymentParametersId, newPaymentFrequency) {
    this.commandName = "ChangePaymentFrequency";

    this.paymentParametersId = paymentParametersId;
    this.newPaymentFrequency = newPaymentFrequency;

    this.description =
      `${i18n.t('CONTENT.events.new_frequency')}: ${i18n.t("CONTENT." + newPaymentFrequency)}`;
  }

  // Use this method to push this command to the server
  serialize() {
    return {
      commandName: this.commandName,
      serialisedCommand: JSON.stringify({
        PaymentParametersId: this.paymentParametersId,
        NewPaymentFrequency: this.newPaymentFrequency
      })
    }
  }

  equal = (other) => equalByNameAndPaymentParametersId(this, other);
}
